import {
  SERVICE_AREA_GEO_SUMMARY,
  SERVICE_AREA_BOOKING_HOWTO,
} from '../../features/shared/constants/serviceAreaCopy';

/**
 * Shared FAQ copy for GEO: visible UI + matching JSON-LD (FAQPage).
 * Keep answers plain text — no HTML — for schema validators.
 */

export const GEO_HOME_FAQ = [
  {
    question: 'What is Fixome and where do you operate?',
    answer:
      `Fixome is a home maintenance platform that connects you with verified technicians for plumbing, electrical, AC repair, cleaning, painting, pest control, and more. ${SERVICE_AREA_GEO_SUMMARY}`,
  },
  {
    question: 'How fast can I get a technician in an emergency?',
    answer:
      'When you book, you choose Emergency, Same day, or Within 48 hours, subject to availability and your exact location in our service area. Response times are shown when you choose urgency during booking.',
  },
  {
    question: 'How does the Fixome booking fee work?',
    answer:
      'The booking fee covers the technician visit to assess the issue. If you approve the quote and we complete the work, the booking fee is typically credited toward your final bill—so you are not double-charged for the visit.',
  },
  {
    question: 'What are the urgency levels and booking fees on Fixome?',
    answer:
      'You can choose Emergency (fastest response), 24-hour, or 48-hour options where available. Booking fees vary by urgency (for example ₹299 for emergency, ₹199 for same-day, ₹99 for within 48 hours)—exact amounts are shown at booking for your selected service.',
  },
  {
    question: 'Are Fixome technicians verified?',
    answer:
      'Yes. Technicians on Fixome go through verification and background checks. Customers also rate jobs, and we use ratings to maintain quality across the network.',
  },
  {
    question: 'How do I book a home service on Fixome?',
    answer:
      SERVICE_AREA_BOOKING_HOWTO,
  },
  {
    question: 'What payment methods does Fixome accept?',
    answer:
      'You can pay securely online (including UPI and cards via our payment partner) where checkout is enabled. Cash and other options may apply for certain jobs—details appear before you pay.',
  },
  {
    question: 'What if I am not satisfied with the service?',
    answer:
      'Contact Fixome support within 24 hours of service completion. We will review your case and work with you on a fair resolution, which may include rework or other remedies depending on the situation.',
  },
];

/** Help page (/help) — must match App.jsx FAQ list for JSON-LD + UI parity */
export const HELP_PAGE_FAQ = [
  {
    question: 'How do I book a service?',
    answer:
      'Go to the homepage, select your service, choose urgency (Emergency, Same day (24h), or Within 48 hours), fill in the details, and confirm—usually in a few clicks.',
  },
  {
    question: 'What are the urgency levels?',
    answer:
      'You choose Emergency, Same day (24h), or Within 48 hours where available, with a ₹299 booking fee for Emergency. Same day (24h) has a ₹199 booking fee. Within 48 hours has a ₹99 booking fee. Exact fees are confirmed at booking.',
  },
  {
    question: 'How does the booking fee work?',
    answer:
      'The booking fee covers the technician visit. If you approve the quote and we complete the work, this fee is credited to your final bill.',
  },
  {
    question: 'Can I track my technician?',
    answer:
      'Yes. Once a technician is assigned, you can get updates on location and ETA in the app flow where tracking is available.',
  },
  {
    question: "What if I'm not satisfied?",
    answer:
      'Contact support within 24 hours of service completion. We will work with you to resolve issues, which may include rework, partial refund, or other remedies depending on the case.',
  },
];
